import { render, staticRenderFns } from "./member-nav.vue?vue&type=template&id=dc7c434a&"
import script from "./member-nav.vue?vue&type=script&lang=js&"
export * from "./member-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports